export const ADD_LANGUAGE: string = 'ADD_LANGUAGE';
export const CLEAR_LANGUAGES: string = 'CLEAR_LANGUAGES';
export const ADD_DEFAULT_LANGUAGE: string = 'ADD_DEFAULT_LANGUAGE';

export function addLanguage(
	langKey: string,
	langVal: string
): IAddLanguageActionType {
	return { type: ADD_LANGUAGE, langKey: langKey, langVal: langVal };
}

export function clearLanguages(): IClearLanguageActionType {
	return { type: CLEAR_LANGUAGES };
}

export function add_default_language(
	defaultLanguage: string
): IAddDefaultLanguageActionType {
	return { type: ADD_DEFAULT_LANGUAGE, defaultLanguage: defaultLanguage };
}

interface IAddLanguageActionType {
	type: string;
	langKey: string;
	langVal: string;
}

interface IClearLanguageActionType {
	type: string;
}

interface IAddDefaultLanguageActionType {
	type: string;
	defaultLanguage: string;
}
